var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
var messages = defineMessages({
    bets_no_bets: {
        id: 'bets.no_bets',
        defaultMessage: 'Нет ставок'
    },
    bets_no_bets_text: {
        id: 'bets.no_bets_text',
        defaultMessage: 'Чтобы выбрать ставку нажмите на ячейку.'
    },
    empty_close: {
        id: 'coupon.empty_close',
        defaultMessage: 'Закрыть'
    },
});
var EmptyCoupon = function (props) {
    return (_jsxs("div", __assign({ className: 'empty-coupon' }, { children: [_jsx("div", __assign({ className: 'title' }, { children: _jsx(FormattedMessage, __assign({}, messages.bets_no_bets)) })), _jsx("div", __assign({ className: 'sub' }, { children: _jsx(FormattedMessage, __assign({}, messages.bets_no_bets_text)) })), _jsx("div", __assign({ className: 'controls' }, { children: _jsx("button", __assign({ onClick: props.close }, { children: _jsx(FormattedMessage, __assign({}, messages.empty_close)) })) }))] })));
};
export default EmptyCoupon;



// WEBPACK FOOTER //
// ./src/components/coupon/EmptyCoupon.jsx